import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { IconImg } from '../../Defaults/Icon/IconImg';
import * as arrowSrc from '../../../../assets/zemplin/up-arrow.svg';

export interface Props {
  children: any;
  title: string;
}

function FooterMenuCol({ title, children }: Props) {
  const [areChildrenVisible, setAreChildrenVisible] = React.useState(false);
  const correctRotation = areChildrenVisible ? 0 : 180;

  return (
    <>
      <DesktopWrapper>
        <Title>{title}</Title>
        {children}
      </DesktopWrapper>
      <MobileWrapper>
        <Title
          // tslint:disable-next-line:jsx-no-lambda
          onClick={() => setAreChildrenVisible(!areChildrenVisible)}
        >
          {title}
          <IconImg
            rotate={correctRotation}
            src={arrowSrc.toString()}
            alt="arrow-icon"
          />
        </Title>
        {areChildrenVisible && children}
      </MobileWrapper>
    </>
  );
}

const DesktopWrapper = styled(FlexCol)`
  margin-right: ${rem(48)};
  flex: 1;

  ${({ theme }) => theme.mediab.m580`
    display: none;
  `}
`;

const Title = styled.h3`
  font-size: ${rem(24)};
  color: ${({ theme }) => theme.color.white};
  margin: 0;
  margin-bottom: ${rem(32)};
  line-height: ${rem(32)};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: row;
  font-weight: 400;

  ${({ theme }) => theme.mediab.m580`
     font-size: ${rem(20)};
     margin-bottom: ${rem(24)};
     line-height: ${rem(28)};
  `}
`;

const MobileWrapper = styled(FlexCol)`
  display: none;
  flex: 1;

  &:last-child {
    ${({ theme }) => theme.mediab.m580`
      margin: 0;
    `}
  }

  ${({ theme }) => theme.mediab.m580`
    display: flex;
    margin-bottom: ${rem(0)};
  `}
`;

export { FooterMenuCol };
